import { request } from "./request";
import Cookies from "js-cookie";
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, AD_ID_COOKIES_KEY } from "@/utils/constant";
import { getAppID, getFbPixelId, getTtPixelId, isTtChannel, setUserInfo } from '@/utils/base'
import { getParam, setStorage, getStorage } from '@/utils/tools'
import { getRandomString } from "@/utils/paypal";

export const fetchGetRankingList = function (data) {
  return request({
    url: "/api/v1/pay_books/ranking",
    method: "post",
    data
  })
}

export const fetchGetHomeList = function (data) {
  return request({
    url: "/api/v1/pay_books/list",
    method: "post",
    data,
  })
}

export const fetchGetSearchList = function (data) {
  return request({
    url: "/api/v1/pay_books/search",
    method: "post",
    data,
  })
}

export const fetchGetTmpUuid = function (data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/api/v1/user/tmp_register",
      method: "post",
      isToast: false,
      data:{
        app_id:getAppID(),
        user_type:0
      },
    }).then(response => {
      fetchReportEvent({
        type: 'test',
        position: 'tmp_register',
        user_id: 'test_user_id',
        ext: JSON.stringify({
          ...response,
          url: window.location.href
        })
      })
      setUserInfo(response.token_info.user_id, response.token_info.accessToken)
      // Cookies.set(USER_ID_COOKIES_KEY, response.token_info.user_id, { expires: 365 })
      // Cookies.set(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken, { expires: 365 })
      
      setStorage(USER_ID_COOKIES_KEY, response.token_info.user_id)
      setStorage(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken)
      resolve(response)
    })
  })
}

export const fetchGetFavbookList = function (data) {
  return request({
    url: "/api/v1/pay_books/favbook_list",
    method: "post",
    data,
  })
}

export const fetchRegister = function (data) {
  return request({
    url: "/api/v1/user/register",
    method: "post",
    data,
  })
}

export const fetchLogin = function (data) {
  return request({
    url: "/api/v1/user/login",
    method: "post",
    data,
  })
}

export const fetchGetBookDetail = function (data) {
  return request({
    url: "/api/v1/pay_books/detail",
    method: "post",
    data,
  })
}

export const fetchAddFavbook = function (data) {
  return request({
    url: "/api/v1/pay_books/favbook",
    method: "post",
    data,
  })
}

export const fetchGetBookChapterList = function (data) {
  return request({
    url: "/api/v1/pay_chapter/list",
    method: "post",
    data,
  })
}

export const fetchGetChapterInfo = function (data) {
  return request({
    url: "/api/v1/pay_chapter/info",
    method: "post",
    data,
  })
}

// 获取档位列表
export const fetchGearList = function (data, isLoading = true) {
  return request({
    url: "/api/v1/order/purchase_list",
    method: "post",
    data,
    isToast: isLoading,
  })
}


export const fetchOrderSubmit = function (data) {
  return request({
    url: "/api/v1/alipay/submit",
    method: "post",
    isToast: false,
    responseType: 'all',
    data: {
      cid: getParam('pid') || '130500',
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchPaypalAppleCapture = function (data){
  return request({
    url: '/api/v1/order/applepaypalcapture',
    method: 'post',
    data: {
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchPixelReport = function(data = {}, type = ''){
  // if(isTtChannel()){
  //   fetchTtReport(data, type)
  // }else{
  //   fetchFbReport(data, type)
  // }
  fetchFbReport(data, type)
}


export const fetchFbReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      fbid: getFbPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      fbp: Cookies.get('_fbp') || "",
      fbc: Cookies.get('_fbc') || "",
    },
    ...data
  }
  console.log('PageView', getFbPixelId())
  window.fbq('init', getFbPixelId()); 
  window.fbq('track', 'PageView');

  return request({
    url: "/api/v1/report/fb",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}

export const fetchTtReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      ttid: getTtPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      ttclid: Cookies.get('ttclid') || "",
      ttp: Cookies.get('_ttp') || "",
    },
    ...data
  }
  if(obj.event === 'pixel_report'){
    if(type === 'PageView'){
      console.log('PageViewTT', getTtPixelId())
      window.ttq.track('PageView');
    }
  }

  return request({
    url: "/api/v1/report/tt",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}

// 每次 useGA4 上报 Google 时,同步把事件镜像到后端 /api/v1/report/ga4
// 跟 fetchFbReport / fetchTtReport 同一套,作为后端埋点的备份通道
export const fetchGa4Report = function (data) {
  if (typeof window === 'undefined') return Promise.resolve()
  // 把 data.properties 单独提出来,跟默认 properties 合并(子字段覆盖),
  // 不能跟 fetchFbReport / fetchTtReport 一样把 ...data 直接顶层展开,
  // 否则 caller 传 properties 时会把默认的 ip/UA/url 整对象覆盖掉
  const { properties: dataProperties, ...restData } = data || {}
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(),
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: Object.assign({
      client_id: '',
      session_id: '',
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
    }, dataProperties),
    ...restData
  }
  return request({
    url: "/api/v1/report/ga4",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data: obj,
  })
}



// 埋点统计上报
export const fetchReportEvent = function (data) {
  return request({
    url: "/api/v1/data/receive",
    method: "post",
    isToast: false,
    data: {
      app_id: getAppID(),
      user_id: Cookies.get(USER_ID_COOKIES_KEY),
      idfp: Cookies.get(AD_ID_COOKIES_KEY) || '', // 传 ad_id
      ...data
    },
  })
}